<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>트레이 리스트</h2>
      </div>
      <div class="table-btn center-right">
        <div class="btn-renew" @click="refreshList">
          <button class="btn btn-40"><span><img src="/static/img/ico-renew@2x.png" alt=""></span></button>
        </div>
        <div class="btn-export-excel" @click="downloadExcel">
          <button class="btn btn-40"><span><img src="/static/img/ico_excel@2x.png" alt=""></span></button>
        </div>
        <div class="btn-frige-register" @click="createTray">
          <button class="btn btn-140"><span><img src="/static/img/ico-plus-white@2x.png" alt=""></span>트레이 등록</button>
        </div>
      </div>
    </div>
    <div class="table-desc" ref="myTable">
      <table>
        <tr class="header">
          <th>트레이 ID</th>
          <th>트레이 이름</th>
          <th>상품 이름</th>
          <th>판매가</th>
          <th>용량</th>
          <th>등록 상품수</th>
          <th>소유회사</th>
          <th>소유회사 운영자</th>
        </tr>

        <tbody v-if="loading === false && total > 0">
          <tr v-for="item in list" :key="item.trayID" @click="goDetail(item)">
            <td>
              <!-- TODO <div>{{ item.trayAlias }}</div> -->
              <div>{{ item.trayID }}</div>
            </td>
            <td>
              <div>{{ item.trayName }}</div>
            </td>
            <td>
              <div>{{ item.product.productName }}</div>
            </td>
            <td>
              <div>{{ item.product.salePrice }}</div>
            </td>
            <td>
              <div>{{ item.product.capacity }}</div>
            </td>
            <td>
              <div>{{ item.product.currentCount }}</div>
            </td>
            <td>
              <div>{{ item.companyName }}</div>
            </td>
            <td>
              <div>{{ item.operatorName }}</div>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="8" class="text-center">{{ loading ? '조회 중입니다.' : '조회 내역이 없습니다.' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
/* eslint-disable no-continue */
/* eslint-disable no-await-in-loop */

import Configuration from '@/js/Configuration';
import js2excel from 'js2excel'; // https://github.com/dwqs/js2excel

export default {
  props: [
    'device',
    'selectEvent',
  ],
  data: () => ({
    deviceData: null,
    list: [],
    total: 0,
    loading: true,
    companyID: null,
    companyName: null,
    companyAlias: null,
    divisionID: null,
    divisionName: null,
    divisionAlias: null,
    operatorUID: null,
    operatorName: null,
  }),
  watch: {
    selectEvent() {
      this.getList(false);
    },
  },
  created() {
    this.getList(false);
  },
  updated() {
    this.loadPagination();
  },
  methods: {
    refreshList() {
      this.getList(false);
    },
    savePagination() {
      const key = this.device.id;
      const page = {
        [key]: this.$refs.myTable.scrollTop,
      };
      sessionStorage.setItem('pagination', JSON.stringify(page));
    },
    loadPagination() {
      const key = this.device.id;
      const page = JSON.parse(sessionStorage.getItem('pagination'));
      if (page !== null && page[key] !== undefined) this.$refs.myTable.scrollTop = page[key];
      else if (page !== null && page[key] === undefined) sessionStorage.setItem('pagination', JSON.stringify({ [key]: 0 }));
    },
    async getList(forDownload) {
      const list = [];
      this.loading = true;
      if (!forDownload) {
        this.list = [];
      }

      try {
        const deviceURL = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device/${this.device.id}?withTrays=true`;
        const deviceResult = await this.$http.get(deviceURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (deviceResult.status !== 200) {
          throw new Error(`Response status is "${deviceResult.status}"`);
        }
        if (deviceResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${deviceResult.data.resultCode}"`);
        }
        await this.getCompanyData(deviceResult.data.device.companyID);
        await this.getDivisionData(deviceResult.data.device.divisionID);
        if (deviceResult.data.device.operatorUID) {
          await this.getUserData(deviceResult.data.device.operatorUID);
        }

        if (deviceResult.data.device.trays) {
          for (let i = 0; i < deviceResult.data.device.trays.length; i++) {
            const p = deviceResult.data.device.trays[i];

            p.deviceID = deviceResult.data.device.deviceID;
            p.deviceName = deviceResult.data.device.deviceName;
            p.deviceAlias = deviceResult.data.device.deviceAlias;
            p.companyID = this.companyID;
            p.companyName = this.companyName;
            p.companyAlias = this.companyAlias;
            p.divisionID = this.divisionID;
            p.divisionName = this.divisionName;
            p.divisionAlias = this.divisionAlias;
            p.operatorUID = this.operatorUID;
            p.operatorName = this.operatorName;

            //
            if (p.products && p.products.length > 0) {
              p.product = p.products[0];
            } else {
              p.product = {
                productName: '-',
                salePrice: 0,
                capacity: 0,
                currentCount: 0,
              };
            }

            list.push(p);
          }

          if (!forDownload) {
            this.list = list;
          }
          this.total = this.list.length;
        } else {
          this.total = 0;
        }
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.error(e);
      }
      return list;
    },
    async getCompanyData(companyID) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/company/${companyID}?withDivisions=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          this.companyID = response.data.company.companyID;
          this.companyName = response.data.company.companyName;
          this.companyAlias = response.data.company.companyAlias;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getDivisionData(divisionID) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/division/${divisionID}?withUsers=false`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          this.divisionID = response.data.division.divisionID;
          this.divisionName = response.data.division.divisionName;
          this.divisionAlias = response.data.division.divisionAlias;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async getUserData(operatorUID) {
      try {
        const response = await this.$http.get(
          `${Configuration.value('CACCOUNT_ADDRESS')}/api/v1/caccount/user/${operatorUID}`,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          },
        );
        if (response.data.resultCode === '0000') {
          this.operatorUID = response.data.user.uID;
          this.operatorName = response.data.user.name;
        }
      } catch (e) {
        console.error(e);
      }
    },
    goDetail(tray) {
      this.savePagination();
      this.$emit('trayDetail', tray);
    },
    createTray() {
      // this.$emit('trayCreate', this.deviceData); // TODO
      this.$emit('trayCreate', this.device);
    },
    async downloadExcel() {
      try {
        const trays = [];
        const list = await this.getList(true);
        for (let j = 0; j < list.length; j++) {
          const it = list[j];
          const c = {
            deviceID: it.deviceID,
            deviceName: it.deviceName,
            trayID: it.trayID,
            trayName: it.trayName,
            productName: it.product.productName,
            salePrice: it.product.salePrice,
            capacity: it.product.capacity,
            currentCount: it.product.currentCount,
            companyID: it.companyID,
            companyName: it.companyName,
            divisionID: it.divisionID,
            divisionName: it.divisionName,
            operatorUID: it.operatorUID,
            operatorName: it.operatorName,
          };
          trays.push(c);
        }
        if (trays.length === 0) {
          alert('다운로드할 내용이 없습니다.');
          return;
        }

        js2excel.json2excel({
          data: trays,
          name: 'cella-tray',
          formateDate: 'yyyy/mm/dd',
        });
      } catch (e) {
        console.error('downloadExcel error', e);
      }
      /*
      // for webpack 3: dynamic import
      // webpackChunkName: "js2excel"
      import('js2excel').then(({ json2excel }) => {
        json2excel({
          data: this.list,
          name: this.downloadFileName,
          formateDate: 'dd/mm/yyyy',
        });
      }).catch((e) => {

      });
      */
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tray/TrayList.vue